// Single source of truth for LocalBusiness structured data (Columbus, GA HQ).
export const NAP = {
  name: "MyStudio",
  street: "2300 Whittlesey Rd Ste E",
  locality: "Columbus",
  region: "GA",
  postalCode: "31909",
  country: "US",
  telephone: "+1-706-478-7640",
  email: "info@bookmystudiospace.com",
  url: "https://bookmystudiospace.com",
};

export const serviceAreas = [
  "Columbus, GA",
  "Phenix City, AL",
  "Fort Moore, GA",
  "Midland, GA",
  "Harris County, GA",
  "Auburn, AL",
  "LaGrange, GA",
  "Atlanta, GA",
];

export const localBusinessSchema = (overrides: Record<string, unknown> = {}) => ({
  "@context": "https://schema.org",
  "@type": ["LocalBusiness", "PhotographyBusiness"],
  "@id": "https://bookmystudiospace.com/#localbusiness",
  name: NAP.name,
  description:
    "Photo and video studio rental in Columbus, GA. Hourly bookings with pro lighting, cyclorama wall, seamless backdrops, and a beauty station.",
  url: NAP.url,
  telephone: NAP.telephone,
  email: NAP.email,
  image: "https://bookmystudiospace.com/favicon.png",
  priceRange: "$$",
  currenciesAccepted: "USD",
  address: {
    "@type": "PostalAddress",
    streetAddress: NAP.street,
    addressLocality: NAP.locality,
    addressRegion: NAP.region,
    postalCode: NAP.postalCode,
    addressCountry: NAP.country,
  },
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      opens: "09:00",
      closes: "21:00",
    },
  ],
  areaServed: serviceAreas.map((a) => ({ "@type": "Place", name: a })),
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Studio rental",
    itemListElement: [
      {
        "@type": "Offer",
        name: "Studio A hourly rental",
        priceCurrency: "USD",
        price: "45",
        url: "https://bookmystudiospace.com/book",
      },
      {
        "@type": "Offer",
        name: "Studio B hourly rental",
        priceCurrency: "USD",
        price: "70",
        url: "https://bookmystudiospace.com/book",
      },
    ],
  },
  sameAs: [
    "https://www.instagram.com/bookmystudiospace",
    "https://www.facebook.com/bookmystudiospace",
  ],
  ...overrides,
});

export const faqSchema = (items: { q: string; a: string }[]) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: items.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

export const breadcrumbSchema = (trail: { name: string; path: string }[]) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: trail.map((t, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: t.name,
    item: `https://bookmystudiospace.com${t.path}`,
  })),
});
